// import DeviceUUID from '@common/deviceid';
import cookies from 'js-cookie';

/**
 * 提取顶级域名
 * @param {?string=} hostname
 * @return {string} 返回顶级域名
 */
export function resolveTopLevelDomain(hostname: string) {
    if (!hostname) {
        return '';
    }

    if (hostname.split(':')[0] === '127.0.0.1') return '';

    const ret = hostname.split('.');
    const len = ret.length;
    return (len <= 2 ? '' : `.${ret[len - 2]}.${ret[len - 1]}`);
}

export const UNIQUE_ID_COOKIE_KEY = 'web_uq';
export const P_STR_COOKIE_KEY = 'web_pstr';

export function generateUniqueId() {
    try {
        // const uqId = cookies.get(UNIQUE_ID_COOKIE_KEY);
    
        // const dd = new DeviceUUID();
        // dd.getLaguage();
        // const newUqId = dd.get(dd.Agent.language);
        // if (uqId || newUqId === uqId) {
        //     return uqId;
        // } 
        
        // console.log('unique_id', newUqId);
        // cookies.set(UNIQUE_ID_COOKIE_KEY, newUqId, {
        //     expires: 365,
        //     path: '/',
        //     domain: resolveTopLevelDomain(window.location.host),
        // });
    } catch (error) {
        console.log(error);
    }
    
}

export function generateIpId() {
    try {
        
        const pStrId = cookies.get(P_STR_COOKIE_KEY);
        const curPstr = window.__INITIAL_STATE__?.initData?.pStr;
    
        if (pStrId) {
            if (pStrId === curPstr || pStrId.indexOf(curPstr) !== -1) {
                return pStrId;
            } 
            if (curPstr) {
                cookies.set(P_STR_COOKIE_KEY, `${pStrId}_${curPstr}`, {
                    expires: 7,
                    path: '/',
                    domain: resolveTopLevelDomain(window.location.host),
                });
            } else {
                return pStrId;
            }
        } else if (curPstr) {
            cookies.set(P_STR_COOKIE_KEY, curPstr, {
                expires: 7,
                path: '/',
                domain: resolveTopLevelDomain(window.location.host),
            });
        } else {
            return '';
        }
    } catch (error) {
        console.log(error);
    }
}